import { render, staticRenderFns } from "./TippaniHeader.vue?vue&type=template&id=2ca9da8f&scoped=true&"
import script from "./TippaniHeader.vue?vue&type=script&lang=js&"
export * from "./TippaniHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9da8f",
  null
  
)

export default component.exports